import React from 'react';

import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  VStack,
  Text,
  Badge,
  Button,
  HStack,
} from '@chakra-ui/react';

import { DetailField, DetailSection } from './DetailField';
import { useColors } from './colors';
import { formatOrderDate } from '../../utils/orderStatus.util';

const FulfillmentTab = ({ order }) => {
  const { borderColor, headerBg, textColor, subTextColor, cardBg } = useColors();
  const isEbay = order.marketplace === 'ebay';
  const packages = order.packages || [];
  const fulfillments = order.fulfillmentHrefs || [];

  return (
    <VStack align="stretch" spacing={5}>
      <HStack justify="space-between" flexWrap="wrap">
        <Text fontSize="sm" color={subTextColor}>
          {isEbay
            ? 'Shipping fulfillments and tracking from eBay Fulfillment API.'
            : 'Packages and tracking from Amazon SP-API includedData=PACKAGES,FULFILLMENT.'}
        </Text>
        <Button size="sm" colorScheme="blue" isDisabled>
          Mark shipped
        </Button>
      </HStack>

      <DetailSection title="Fulfillment status">
        <DetailField
          label={isEbay ? 'Order fulfillment status' : 'Order status'}
          value={order.orderFulfillmentStatus || order.orderStatus}
        />
        <DetailField label="Channel" value={order.fulfillmentChannel} />
        {!isEbay && order.fulfillment?.shipServiceLevel && (
          <DetailField label="Ship service level" value={order.fulfillment.shipServiceLevel} />
        )}
      </DetailSection>

      {packages.length > 0 ? (
        <Box
          bg={cardBg}
          borderWidth="1px"
          borderColor={borderColor}
          borderRadius="lg"
          overflowX="auto"
        >
          <Text fontWeight="semibold" p={4} pb={2} color={textColor} fontSize="md">
            Packages & tracking
          </Text>
          <Table size="sm">
            <Thead bg={headerBg}>
              <Tr>
                <Th>Carrier</Th>
                <Th>Tracking #</Th>
                <Th>Ship date</Th>
                <Th>Status</Th>
              </Tr>
            </Thead>
            <Tbody>
              {packages.map((pkg, i) => (
                <Tr key={i}>
                  <Td>{pkg.carrierCode || pkg.carrier}</Td>
                  <Td fontFamily="mono" fontSize="sm">
                    {pkg.trackingNumber}
                  </Td>
                  <Td fontSize="xs">{formatOrderDate(pkg.shipDate)}</Td>
                  <Td>
                    <Badge colorScheme="green" variant="subtle">
                      {pkg.status || 'Shipped'}
                    </Badge>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      ) : (
        <Box
          bg={cardBg}
          borderWidth="1px"
          borderColor={borderColor}
          borderRadius="lg"
          p={8}
          textAlign="center"
        >
          <Text fontWeight="medium" color={textColor} mb={1}>
            No shipments recorded
          </Text>
          <Text fontSize="sm" color={subTextColor}>
            Tracking and package details will appear here after fulfillment is created.
          </Text>
        </Box>
      )}

      {isEbay && fulfillments.length > 0 && (
        <DetailSection title="Fulfillment references" columns={1}>
          {fulfillments.map((href, i) => (
            <DetailField key={i} label={`Fulfillment ${i + 1}`} value={href} mono />
          ))}
        </DetailSection>
      )}
    </VStack>
  );
};

export default FulfillmentTab;
